import DogUIISUCSSA from './dogui-isu-cssa';
import logo from './component/logo';

export default DogUIISUCSSA;
export const Logo = logo;